import { render } from "./ContactButton.vue?vue&type=template&id=1093fedf&lang=pug"
import script from "./ContactButton.vue?vue&type=script&lang=js"
export * from "./ContactButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__